// #region Namespace
// #endregion
export default class ActionFactory {
    // #region Vars
    _actions = new Map();
    // #endregion
    // #region Konstanten
    //fileFilter?: RegExp = /(?<!modules)\.ts$/;
    // #endregion
    // #region Boostrap
    register(options) {
        //Append
        if (Option.name) {
            this._actions.set(options.name, options);
        }
        return options;
    }
    registerAll(context) {
        context.keys().forEach(e => {
            //Load
            let tAction = context(e).default;
            //Set
            if (tAction && tAction.name) {
                this._actions.set(tAction.name, tAction);
            }
        });
    }
    // #endregion
    // #region Run
    async tryExecute(name, data, params, showError = true) {
        // #region Find
        var tDefinition = this._actions.get(name);
        if (!tDefinition) {
            return {
                isSucceeded: false,
                error: {
                    name: 'core_action_definitionNotFound',
                    message: `Die Action-Definition "${name}" wurde nicht gefunden.`
                }
            };
        }
        ;
        // #endregion        
        // #region Build
        var tInstance = {
            //Defaults
            name: tDefinition.name,
            //Interaction
            beforeExecute: tDefinition.beforeExecute,
            afterExecute: tDefinition.afterExecute,
            execute: tDefinition.execute,
            //System
            $host: host,
            $store: host.store,
            $options: tDefinition,
            $utils: utils,
            //Functions:
            Ok: function (result) {
                return {
                    isSucceeded: true,
                    result: result
                };
            },
            Cancel: function (result) {
                return {
                    isSucceeded: false,
                    result: result
                };
            },
            Error: function (exception, result) {
                return {
                    isSucceeded: false,
                    result: result,
                    error: (exception instanceof Error) ? exception : {
                        name: '',
                        message: exception
                    }
                };
            },
            Return: function (errorOrResult, result) {
                return {
                    isSucceeded: utils.isBoolean(errorOrResult) ? errorOrResult : false,
                    result: result,
                    error: (errorOrResult instanceof Error) ? errorOrResult : (utils.isString(errorOrResult) ? {
                        name: '',
                        message: errorOrResult
                    } : undefined)
                };
            },
            Window(result) {
                return {
                    isSucceeded: result.state === 1 || result.result === 6,
                    result: result.result,
                    error: result.error
                };
            }
        };
        let methods = tDefinition.methods;
        if (methods) {
            for (const key in methods) {
                const methodHandler = methods[key];
                if (utils.isFunction(methodHandler)) {
                    Object.defineProperty(tInstance, key, {
                        value: methodHandler.bind(tInstance),
                        configurable: true,
                        enumerable: true,
                        writable: true
                    });
                }
            }
        }
        // #endregion
        // #region Run
        if (tInstance.beforeExecute) {
            tInstance.beforeExecute();
        }
        //Core
        let tResult = await tInstance.execute(data, params);
        //After
        if (tInstance.afterExecute) {
            tInstance.afterExecute(tResult);
        }
        if (showError && !tResult.isSucceeded && tResult.error) {
            host.notification.showToast(tResult.error.message, "error");
        }
        // #endregion
        return tResult;
    }
}
